(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sm-bis"] && !Shopify.designMode) return;
  try {
    // Eén gedelegeerde handler voor elk BIS-formulier op de pagina, nu en later.
  (function () {
    if (window.__smBis) return;
    window.__smBis = true;

    var REVISIE = '2026-01-15';

    function melden(form, tekst, stand) {
      var el = form.querySelector('.bis-melding');
      if (!el) return;
      el.setAttribute('data-stand', stand);
      el.textContent = tekst;
    }

    function post(pad, key, body) {
      return fetch('https://a.klaviyo.com/client/' + pad + '/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISIE },
        body: JSON.stringify(body)
      });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('form[data-bis]') : null;
      if (!form) return;
      e.preventDefault();

      var veld = form.querySelector('.bis-mail');
      var knop = form.querySelector('.bis-knop');
      var mail = veld ? veld.value.trim() : '';
      var key = form.getAttribute('data-bis-key');
      var variant = form.getAttribute('data-bis-variant');

      // Dezelfde toets die Klaviyo zelf doet. `type="email"` vangt het meeste al
      // af, maar novalidate staat aan omdat de browsermelding niet te stylen is.
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
        if (veld) {
          veld.setAttribute('aria-invalid', 'true');
          veld.focus();
        }
        melden(form, 'Vul een geldig e-mailadres in.', 'fout');
        return;
      }
      if (veld) veld.removeAttribute('aria-invalid');
      if (knop) knop.disabled = true;

      post('back-in-stock-subscriptions', key, {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: mail } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } }
          }
        }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Klaviyo ' + res.status);

          var rij = form.querySelector('.bis-rij');
          var uitleg = form.querySelector('.bis-uitleg');
          melden(form, 'Gelukt — je krijgt bericht zodra dit weer op voorraad is.', 'klaar');

          // Focus eerst verplaatsen, dán pas de rij weghalen. De focus stond op de
          // knop of het veld en die zitten allebei ín die rij; verdwijnt hij eerst,
          // dan valt de focus terug naar <body> en verliest een toetsenbord- of
          // schermlezergebruiker zijn plek precies op het moment dat de melding
          // voorgelezen moet worden.
          var melding = form.querySelector('.bis-melding');
          if (melding) melding.focus();
          if (rij) rij.hidden = true;
          if (uitleg) uitleg.hidden = true;
        })
        .catch(function () {
          melden(form, 'Er ging iets mis. Probeer het zo nog eens.', 'fout');
          if (knop) knop.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-filterbalk"] && !Shopify.designMode) return;
  try {
    // Verrijking, geen voorwaarde: zonder JS submit de bezoeker met de knop uit
  // <noscript>. Hier vervangt een wijziging die klik.
  //
  // Gedelegeerd op document, niet per formulier: dit blok draait één keer per
  // paginalading, terwijl de theme-editor de sectie opnieuw rendert bij elke
  // instelling. Een direct gebonden listener is daarna weg en de balk doet dan
  // niets meer — de noscript-knop staat er niet als JS aan staat.
  document.addEventListener('change', (e) => {
    e.target.closest('[data-fbar-form]')?.submit();
  });
  } catch(e) { console.error(e); }
})();

})();
